module.exports = __webpack_public_path__ + "static/img/gaoxiao.0a96490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gaoxiao.jpg
// module id = 6uX5
// module chunks = 0